export default {"src":"/_next/static/media/Female-02.38c9e34b.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};